// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23d4d4aa%27 fill-opacity=%270.1%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced WhatsApp Web Clone CSS */
.whatsapp-web {
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #f0f2f5;
  overflow: hidden;
}

/* Mobile First Approach */
@media (max-width: 768px) {
  .whatsapp-web {
    height: 100vh;
    height: 100dvh; /* Use dynamic viewport height for mobile */
  }
}

.header {
  background-color: #00a884;
  color: white;
  padding: 10px 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.back-to-dashboard-btn {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.back-to-dashboard-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.back-to-dashboard-btn:active {
  transform: translateY(0);
}

/* Mobile responsive for back button */
@media (max-width: 768px) {
  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .back-to-dashboard-btn {
    font-size: 12px;
    padding: 6px 12px;
    align-self: flex-start;
  }
  
  .header-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .back-to-dashboard-btn {
    width: 100%;
    justify-content: center;
  }
  
  .header {
    padding: 8px 16px;
  }
}

.header-title {
  font-size: 19px;
  font-weight: 500;
}

.connection-status {
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 12px;
  background-color: rgba(255,255,255,0.1);
}

.connection-status.connected {
  background-color: rgba(34, 197, 94, 0.2);
}

.connection-status.disconnected {
  background-color: rgba(239, 68, 68, 0.2);
}

.main-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* Mobile Layout */
@media (max-width: 768px) {
  .main-container {
    position: relative;
  }
  
  /* Hide sidebar on mobile when chat is selected */
  .main-container.chat-selected .sidebar {
    display: none;
  }
  
  /* Show chat area full width on mobile */
  .main-container.chat-selected .chat-area {
    width: 100%;
  }
}

.sidebar {
  width: 360px;
  background-color: white;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
}

/* Mobile Sidebar */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 100;
    border-right: none;
    transition: transform 0.3s ease;
  }
  
  .sidebar.hidden {
    transform: translateX(-100%);
  }
  
  /* Ensure sidebar is visible by default on mobile */
  .main-container:not(.chat-selected) .sidebar {
    transform: translateX(0);
    display: flex;
  }
}

.sidebar-header {
  padding: 20px 16px 10px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile Sidebar Header */
@media (max-width: 768px) {
  .sidebar-header {
    padding: 16px 12px 12px;
  }
  
  .sidebar-header h3 {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .sidebar-header {
    padding: 14px 10px 10px;
  }
  
  .sidebar-header h3 {
    font-size: 16px;
  }
}

.sidebar-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.new-chat-btn, .refresh-btn {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  color: #6b7280;
  font-size: 16px;
  transition: background-color 0.2s;
}

.new-chat-btn:hover, .refresh-btn:hover {
  background-color: #e5e7eb;
}

/* Search Container */
.search-container {
  position: relative;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
}

/* Mobile Search Container */
@media (max-width: 768px) {
  .search-container {
    padding: 10px 12px;
  }
}

@media (max-width: 480px) {
  .search-container {
    padding: 8px 10px;
  }
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  background-color: white;
}

/* Mobile Search Input */
@media (max-width: 768px) {
  .search-input {
    padding: 12px 40px 12px 16px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
}

@media (max-width: 480px) {
  .search-input {
    padding: 10px 36px 10px 14px;
    border-radius: 6px;
  }
}

.search-input:focus {
  border-color: #00a884;
  box-shadow: 0 0 0 1px #00a884;
}

.search-icon {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 16px;
}

.contacts-list {
  flex: 1 1;
  overflow-y: auto;
}

/* No contacts / search results */
.no-contacts {
  padding: 20px;
  text-align: center;
  color: #6b7280;
}

.no-search-results p {
  margin: 0 0 16px 0;
  font-size: 14px;
}

.clear-search-btn {
  background-color: #00a884;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.clear-search-btn:hover {
  background-color: #008a73;
}

/* Search highlight */
.highlight {
  background-color: #fef3c7;
  font-weight: 600;
  color: #92400e;
  padding: 1px 2px;
  border-radius: 2px;
}

/* Image Modal */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.image-modal {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: modalSlideIn 0.3s ease;
}

.image-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
}

.image-modal-controls {
  display: flex;
  gap: 4px;
}

.image-modal-actions {
  display: flex;
  gap: 4px;
}

.zoom-btn {
  background: #e5e7eb;
  border: none;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #374151;
  font-weight: 500;
}

.zoom-btn:hover:not(:disabled) {
  background-color: #d1d5db;
}

.zoom-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.image-modal-close,
.image-modal-download {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
  color: #6b7280;
}

.image-modal-close:hover,
.image-modal-download:hover {
  background-color: #e5e7eb;
  color: #374151;
}

.image-modal-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  max-height: calc(90vh - 120px);
  overflow: auto;
  background: #f8f9fa;
}

.modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
  cursor: grab;
}

.modal-image:active {
  cursor: grabbing;
}

.image-error {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

.image-error button {
  margin-top: 16px;
  background: #00a884;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.image-modal-footer {
  padding: 12px 16px;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
  text-align: center;
}

.image-modal-footer p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

/* Modal animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes modalSlideIn {
  from { 
    opacity: 0; 
    transform: scale(0.9) translateY(-20px); 
  }
  to { 
    opacity: 1; 
    transform: scale(1) translateY(0); 
  }
}

/* Mobile responsive for image modal */
@media (max-width: 768px) {
  .image-modal {
    max-width: 95vw;
    max-height: 85vh;
    margin: 20px;
  }
  
  .image-modal-header {
    padding: 8px 12px;
  }
  
  .image-modal-close,
  .image-modal-download {
    font-size: 18px;
    padding: 6px;
  }
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;
}

.contact-item:hover {
  background-color: #f9fafb;
}

.contact-item.active {
  background-color: #e5f3ff;
}

.contact-item.admin-mode {
  background-color: #fef3c7 !important; /* More prominent yellow background */
  border-left: 4px solid #f59e0b !important; /* Orange-yellow left border */
  box-shadow: 0 0 8px rgba(245, 158, 11, 0.3) !important; /* Yellow glow effect */
}

.contact-item.admin-mode:hover {
  background-color: #fbbf24 !important; /* Darker yellow on hover */
}

.contact-item.admin-mode.active {
  background-color: #f59e0b !important; /* Very prominent yellow when active and in admin mode */
  color: white !important; /* White text for better contrast */
}

.contact-item.admin-mode.active .contact-name,
.contact-item.admin-mode.active .contact-last-message,
.contact-item.admin-mode.active .contact-time {
  color: white !important;
}

/* Mobile Contact Items */
@media (max-width: 768px) {
  .contact-item {
    padding: 16px;
    min-height: 72px;
  }
  
  .contact-avatar {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }
  
  .contact-name {
    font-size: 16px;
  }
  
  .contact-last-message {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .contact-item {
    padding: 14px;
    min-height: 68px;
  }
  
  .contact-avatar {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
}

.admin-badge {
  margin-left: 8px;
  font-size: 12px;
  background-color: #f59e0b;
  color: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 500;
}

.contact-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #6b7280;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 12px;
  font-size: 18px;
}

.contact-info {
  flex: 1 1;
  min-width: 0;
}

.contact-name {
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-last-message {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-meta {
  text-align: right;
  margin-left: 8px;
}

.contact-time {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 4px;
}

.message-count {
  background-color: #00a884;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}

.chat-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: #efeae2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: relative; /* Add relative positioning for scroll button */
}

/* Mobile Chat Area */
@media (max-width: 768px) {
  .chat-area {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 90;
  }
  
  .chat-area.hidden-mobile {
    display: none;
  }
}

.chat-header {
  background-color: #f0f2f5;
  padding: 16px 20px;
  border-bottom: 1px solid #d1d7db;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Mobile Back Button */
.mobile-back-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #54656f;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-back-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* Mobile Chat Header */
@media (max-width: 768px) {
  .chat-header {
    padding: 12px 16px;
  }
}

.chat-contact-info {
  display: flex;
  align-items: center;
}

.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #6b7280;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 12px;
  font-size: 16px;
}

.chat-name {
  font-weight: 600;
  color: #111827;
  margin-bottom: 2px;
}

.chat-status {
  font-size: 13px;
  color: #667781;
}

.messages-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');
  background-size: auto;
}

/* Mobile Messages Container */
@media (max-width: 768px) {
  .messages-container {
    padding: 10px 15px;
  }
}

/* Scroll to Bottom Button */
.scroll-to-bottom {
  position: absolute;
  bottom: 80px;
  right: 20px;
  z-index: 10;
}

.scroll-to-bottom-btn {
  background: #00a884;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  animation: slideUp 0.3s ease-out;
  white-space: nowrap;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.scroll-to-bottom-btn:hover {
  background: #008f70;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.scroll-to-bottom-btn:active {
  transform: translateY(0);
}

/* Mobile Scroll Button */
@media (max-width: 768px) {
  .scroll-to-bottom {
    bottom: 70px;
    right: 16px;
  }
  
  .scroll-to-bottom-btn {
    padding: 10px 14px;
    font-size: 13px;
  }
}

/* Drag and Drop Overlay */
.drag-drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 168, 132, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border: 3px dashed rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  backdrop-filter: blur(5px);
}

.drag-drop-content {
  text-align: center;
  color: white;
  pointer-events: none;
}

.drag-drop-icon {
  font-size: 64px;
  margin-bottom: 16px;
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.drag-drop-content h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
}

.drag-drop-content p {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

/* Mobile Drag and Drop */
@media (max-width: 768px) {
  .drag-drop-icon {
    font-size: 48px;
    margin-bottom: 12px;
  }
  
  .drag-drop-content h3 {
    font-size: 20px;
  }
  
  .drag-drop-content p {
    font-size: 14px;
  }
}

.message {
  display: flex;
  margin-bottom: 2px;
  animation: messageSlideIn 0.2s ease-out;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.sent {
  justify-content: flex-end;
}

.message.received {
  justify-content: flex-start;
}

.message-content {
  max-width: 65%;
  min-width: 100px;
  background-color: white;
  border-radius: 7.5px;
  padding: 6px 7px 8px 9px;
  box-shadow: 0 1px 0.5px rgba(0,0,0,0.13);
  position: relative;
  word-wrap: break-word;
}

.message.sent .message-content {
  background-color: #d9fdd3;
  border-radius: 7.5px 7.5px 0px 7.5px;
}

.message.received .message-content {
  background-color: #ffffff;
  border-radius: 7.5px 7.5px 7.5px 0px;
}

.message-text {
  margin: 0;
  color: #111827;
  line-height: 1.4;
  word-wrap: break-word;
  font-size: 14px;
}

.message-time {
  font-size: 11px;
  color: #667781;
  margin-top: 2px;
  float: right;
  margin-left: 10px;
}

.message-status {
  color: #53bdeb;
  margin-left: 3px;
}

.media-message {
  max-width: 300px;
}

.image-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.message-image {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  display: block;
  transition: all 0.2s ease;
}

.clickable-image {
  cursor: pointer;
}

.clickable-image:hover {
  opacity: 0.9;
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.media-placeholder {
  background-color: #f3f4f6;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

.document-message {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 4px;
}

.document-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.document-icon {
  font-size: 24px;
  color: #6b7280;
}

.document-details {
  flex: 1 1;
  min-width: 0; /* Allow text truncation */
}

.document-name {
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-size {
  font-size: 12px;
  color: #6b7280;
}

.download-btn {
  background-color: #00a884;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.download-btn:hover {
  background-color: #008a73;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

/* Audio Message Styles */
.audio-container {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  max-width: 350px;
}

.message-audio {
  width: 100%;
  height: 40px;
  margin-bottom: 8px;
  border-radius: 20px;
  outline: none;
}

.message-audio::-webkit-media-controls-panel {
  background-color: #f3f4f6;
  border-radius: 20px;
}

.message-audio::-webkit-media-controls-play-button,
.message-audio::-webkit-media-controls-pause-button {
  background-color: #00a884;
  border-radius: 50%;
}

.audio-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.audio-icon {
  font-size: 20px;
  color: #00a884;
}

.audio-details {
  flex: 1 1;
  min-width: 0;
}

.audio-name {
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.audio-size {
  font-size: 12px;
  color: #6b7280;
}

.audio-message {
  background-color: #f3f4f6;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

/* Video Message Styles */
.video-container {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  max-width: 400px;
}

.message-video {
  width: 100%;
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  margin-bottom: 8px;
  background-color: #000;
}

.message-video::-webkit-media-controls-panel {
  background-color: rgba(0, 0, 0, 0.8);
}

.message-video::-webkit-media-controls-play-button,
.message-video::-webkit-media-controls-pause-button {
  background-color: #00a884;
  border-radius: 50%;
}

.video-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.video-icon {
  font-size: 20px;
  color: #00a884;
}

.video-details {
  flex: 1 1;
  min-width: 0;
}

.video-name {
  font-weight: 500;
  color: #111827;
  margin-bottom: 2px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-size {
  font-size: 12px;
  color: #6b7280;
}

.video-message {
  background-color: #f3f4f6;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

/* Media Player Responsive Design */
@media (max-width: 768px) {
  .audio-container,
  .video-container {
    max-width: 280px;
  }
  
  .message-video {
    max-height: 200px;
  }
  
  .message-audio {
    height: 35px;
  }
  
  .audio-info,
  .video-info {
    gap: 8px;
  }
  
  .audio-name,
  .video-name {
    font-size: 13px;
  }
  
  .audio-size,
  .video-size {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .audio-container,
  .video-container {
    max-width: 250px;
  }
  
  .message-video {
    max-height: 150px;
  }
  
  .download-btn {
    padding: 6px 10px;
    font-size: 12px;
  }
}

/* Media Loading and Error States */
.media-loading {
  display: none;
  text-align: center;
  padding: 10px;
  color: #6b7280;
  font-size: 14px;
  font-style: italic;
}

.audio-error,
.video-error {
  display: none;
  text-align: center;
  padding: 10px;
  color: #ef4444;
  font-size: 14px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  margin: 8px 0;
}

/* Custom Media Controls Styling */
.message-audio::-webkit-media-controls-timeline,
.message-video::-webkit-media-controls-timeline {
  background-color: #e5e7eb;
  border-radius: 4px;
}

.message-audio::-webkit-media-controls-current-time-display,
.message-audio::-webkit-media-controls-time-remaining-display,
.message-video::-webkit-media-controls-current-time-display,
.message-video::-webkit-media-controls-time-remaining-display {
  color: #374151;
  font-size: 12px;
}

.message-audio::-webkit-media-controls-volume-slider,
.message-video::-webkit-media-controls-volume-slider {
  background-color: #e5e7eb;
  border-radius: 4px;
}

.download-btn:hover {
  background-color: #059669;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.download-btn:active {
  transform: translateY(0);
}

.media-caption {
  margin: 8px 0 0;
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
}

.file-size {
  font-size: 11px;
  color: #9ca3af;
}

.audio-message, .video-message {
  background-color: #f3f4f6;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #6b7280;
}

.message-input-container {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background-color: #f0f2f5;
  gap: 12px;
}

/* Mobile Input Container */
@media (max-width: 768px) {
  .message-input-container {
    padding: 12px 16px;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .message-input-container {
    padding: 10px 12px;
    gap: 6px;
  }
}

.attach-btn, .send-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #54656f;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

/* Mobile Touch-Friendly Buttons */
@media (max-width: 768px) {
  .attach-btn, .send-btn {
    padding: 12px;
    font-size: 22px;
    min-width: 44px;
    height: 44px;
  }
  
  .new-chat-btn, .refresh-btn {
    padding: 12px;
    font-size: 18px;
    min-width: 44px;
    height: 44px;
  }
}

@media (max-width: 480px) {
  .attach-btn, .send-btn {
    padding: 10px;
    font-size: 20px;
    min-width: 40px;
    height: 40px;
  }
}

.attach-btn:hover, .send-btn:hover {
  background-color: #e5e7eb;
}

.message-input {
  flex: 1 1;
  border: none;
  border-radius: 24px;
  padding: 12px 16px;
  font-size: 15px;
  background-color: white;
  outline: none;
}

/* Mobile Message Input */
@media (max-width: 768px) {
  .message-input {
    padding: 10px 14px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
}

@media (max-width: 480px) {
  .message-input {
    padding: 8px 12px;
    border-radius: 20px;
  }
}

.message-input:focus {
  box-shadow: 0 0 0 2px #00a884;
}

.no-chat-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  text-align: center;
  color: #667781;
}

/* Mobile No Chat Selected */
@media (max-width: 768px) {
  .no-chat-selected {
    padding: 20px;
  }
  
  .no-chat-content h3 {
    font-size: 18px;
  }
  
  .feature-list p {
    font-size: 14px;
  }
}

.no-chat-content h3 {
  margin-bottom: 16px;
  color: #111827;
}

.feature-list {
  margin-top: 24px;
}

.feature-list p {
  margin: 8px 0;
  color: #6b7280;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 12px;
  padding: 0;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.modal-header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: #f3f4f6;
}

.modal-content {
  padding: 20px 24px;
}

.modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-cancel, .btn-send {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background-color: #f3f4f6;
  color: #374151;
}

.btn-cancel:hover {
  background-color: #e5e7eb;
}

.btn-send {
  background-color: #00a884;
  color: white;
}

.btn-send:hover {
  background-color: #059669;
}

.btn-send:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

/* New Chat Form */
.new-chat-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.new-chat-form label {
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}

.phone-input {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s;
}

.phone-input:focus {
  border-color: #00a884;
}

.phone-help {
  background-color: #f0f9ff;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid #0ea5e9;
}

.phone-help small {
  color: #0369a1;
  line-height: 1.5;
}

/* File Preview */
.file-preview {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.file-icon {
  font-size: 24px;
}

.file-name {
  font-weight: 500;
  color: #111827;
}

.file-size {
  font-size: 12px;
  color: #6b7280;
}

.image-preview {
  max-width: 100%;
  max-height: 200px;
  border-radius: 6px;
}

.caption-input {
  width: 100%;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  outline: none;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.2s;
}

.caption-input:focus {
  border-color: #00a884;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  
  .sidebar.open {
    transform: translateX(0);
  }
  
  .message-content {
    max-width: 85%;
  }
  
  .modal {
    width: 95%;
    margin: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/WhatsAppWeb.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8EAA8E;EAC9E,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;IACb,cAAc,EAAE,2CAA2C;EAC7D;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;EACpB;;EAEA,iDAAiD;EACjD;IACE,aAAa;EACf;;EAEA,wCAAwC;EACxC;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,mDAAmD;EACnD;IACE,wBAAwB;IACxB,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE;IACE,4BAA4B;IAC5B,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC,EAAE,qCAAqC;EAC3E,yCAAyC,EAAE,8BAA8B;EACzE,sDAAsD,EAAE,uBAAuB;AACjF;;AAEA;EACE,oCAAoC,EAAE,2BAA2B;AACnE;;AAEA;EACE,oCAAoC,EAAE,wDAAwD;EAC9F,uBAAuB,EAAE,mCAAmC;AAC9D;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,yDAA+W;EAC/W,kBAAkB,EAAE,+CAA+C;AACrE;;AAEA,qBAAqB;AACrB;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6HAA6H;EAC7H,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,QAAQ;EACV;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA,kCAAkC;AAClC;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE;IACE,kBAAkB;IAClB,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":["/* Enhanced WhatsApp Web Clone CSS */\n.whatsapp-web {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background-color: #f0f2f5;\n  overflow: hidden;\n}\n\n/* Mobile First Approach */\n@media (max-width: 768px) {\n  .whatsapp-web {\n    height: 100vh;\n    height: 100dvh; /* Use dynamic viewport height for mobile */\n  }\n}\n\n.header {\n  background-color: #00a884;\n  color: white;\n  padding: 10px 20px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.back-to-dashboard-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.back-to-dashboard-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.back-to-dashboard-btn:active {\n  transform: translateY(0);\n}\n\n/* Mobile responsive for back button */\n@media (max-width: 768px) {\n  .header-left {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .back-to-dashboard-btn {\n    font-size: 12px;\n    padding: 6px 12px;\n    align-self: flex-start;\n  }\n  \n  .header-title {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .back-to-dashboard-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .header {\n    padding: 8px 16px;\n  }\n}\n\n.header-title {\n  font-size: 19px;\n  font-weight: 500;\n}\n\n.connection-status {\n  font-size: 14px;\n  padding: 4px 12px;\n  border-radius: 12px;\n  background-color: rgba(255,255,255,0.1);\n}\n\n.connection-status.connected {\n  background-color: rgba(34, 197, 94, 0.2);\n}\n\n.connection-status.disconnected {\n  background-color: rgba(239, 68, 68, 0.2);\n}\n\n.main-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Mobile Layout */\n@media (max-width: 768px) {\n  .main-container {\n    position: relative;\n  }\n  \n  /* Hide sidebar on mobile when chat is selected */\n  .main-container.chat-selected .sidebar {\n    display: none;\n  }\n  \n  /* Show chat area full width on mobile */\n  .main-container.chat-selected .chat-area {\n    width: 100%;\n  }\n}\n\n.sidebar {\n  width: 360px;\n  background-color: white;\n  border-right: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mobile Sidebar */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    z-index: 100;\n    border-right: none;\n    transition: transform 0.3s ease;\n  }\n  \n  .sidebar.hidden {\n    transform: translateX(-100%);\n  }\n  \n  /* Ensure sidebar is visible by default on mobile */\n  .main-container:not(.chat-selected) .sidebar {\n    transform: translateX(0);\n    display: flex;\n  }\n}\n\n.sidebar-header {\n  padding: 20px 16px 10px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Mobile Sidebar Header */\n@media (max-width: 768px) {\n  .sidebar-header {\n    padding: 16px 12px 12px;\n  }\n  \n  .sidebar-header h3 {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sidebar-header {\n    padding: 14px 10px 10px;\n  }\n  \n  .sidebar-header h3 {\n    font-size: 16px;\n  }\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.header-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.new-chat-btn, .refresh-btn {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 16px;\n  transition: background-color 0.2s;\n}\n\n.new-chat-btn:hover, .refresh-btn:hover {\n  background-color: #e5e7eb;\n}\n\n/* Search Container */\n.search-container {\n  position: relative;\n  padding: 12px 16px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* Mobile Search Container */\n@media (max-width: 768px) {\n  .search-container {\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .search-container {\n    padding: 8px 10px;\n  }\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 40px 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n  background-color: white;\n}\n\n/* Mobile Search Input */\n@media (max-width: 768px) {\n  .search-input {\n    padding: 12px 40px 12px 16px;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n}\n\n@media (max-width: 480px) {\n  .search-input {\n    padding: 10px 36px 10px 14px;\n    border-radius: 6px;\n  }\n}\n\n.search-input:focus {\n  border-color: #00a884;\n  box-shadow: 0 0 0 1px #00a884;\n}\n\n.search-icon {\n  position: absolute;\n  right: 28px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n  font-size: 16px;\n}\n\n.contacts-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* No contacts / search results */\n.no-contacts {\n  padding: 20px;\n  text-align: center;\n  color: #6b7280;\n}\n\n.no-search-results p {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n}\n\n.clear-search-btn {\n  background-color: #00a884;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s;\n}\n\n.clear-search-btn:hover {\n  background-color: #008a73;\n}\n\n/* Search highlight */\n.highlight {\n  background-color: #fef3c7;\n  font-weight: 600;\n  color: #92400e;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n/* Image Modal */\n.image-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  animation: fadeIn 0.3s ease;\n}\n\n.image-modal {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  animation: modalSlideIn 0.3s ease;\n}\n\n.image-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.image-modal-controls {\n  display: flex;\n  gap: 4px;\n}\n\n.image-modal-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.zoom-btn {\n  background: #e5e7eb;\n  border: none;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 4px;\n  transition: all 0.2s;\n  color: #374151;\n  font-weight: 500;\n}\n\n.zoom-btn:hover:not(:disabled) {\n  background-color: #d1d5db;\n}\n\n.zoom-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.image-modal-close,\n.image-modal-download {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  transition: background-color 0.2s;\n  color: #6b7280;\n}\n\n.image-modal-close:hover,\n.image-modal-download:hover {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n\n.image-modal-content {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  max-height: calc(90vh - 120px);\n  overflow: auto;\n  background: #f8f9fa;\n}\n\n.modal-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  display: block;\n  transition: transform 0.3s ease;\n  cursor: grab;\n}\n\n.modal-image:active {\n  cursor: grabbing;\n}\n\n.image-error {\n  text-align: center;\n  padding: 40px;\n  color: #6b7280;\n}\n\n.image-error button {\n  margin-top: 16px;\n  background: #00a884;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.image-modal-footer {\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-top: 1px solid #e5e7eb;\n  text-align: center;\n}\n\n.image-modal-footer p {\n  margin: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Modal animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes modalSlideIn {\n  from { \n    opacity: 0; \n    transform: scale(0.9) translateY(-20px); \n  }\n  to { \n    opacity: 1; \n    transform: scale(1) translateY(0); \n  }\n}\n\n/* Mobile responsive for image modal */\n@media (max-width: 768px) {\n  .image-modal {\n    max-width: 95vw;\n    max-height: 85vh;\n    margin: 20px;\n  }\n  \n  .image-modal-header {\n    padding: 8px 12px;\n  }\n  \n  .image-modal-close,\n  .image-modal-download {\n    font-size: 18px;\n    padding: 6px;\n  }\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.2s;\n}\n\n.contact-item:hover {\n  background-color: #f9fafb;\n}\n\n.contact-item.active {\n  background-color: #e5f3ff;\n}\n\n.contact-item.admin-mode {\n  background-color: #fef3c7 !important; /* More prominent yellow background */\n  border-left: 4px solid #f59e0b !important; /* Orange-yellow left border */\n  box-shadow: 0 0 8px rgba(245, 158, 11, 0.3) !important; /* Yellow glow effect */\n}\n\n.contact-item.admin-mode:hover {\n  background-color: #fbbf24 !important; /* Darker yellow on hover */\n}\n\n.contact-item.admin-mode.active {\n  background-color: #f59e0b !important; /* Very prominent yellow when active and in admin mode */\n  color: white !important; /* White text for better contrast */\n}\n\n.contact-item.admin-mode.active .contact-name,\n.contact-item.admin-mode.active .contact-last-message,\n.contact-item.admin-mode.active .contact-time {\n  color: white !important;\n}\n\n/* Mobile Contact Items */\n@media (max-width: 768px) {\n  .contact-item {\n    padding: 16px;\n    min-height: 72px;\n  }\n  \n  .contact-avatar {\n    width: 48px;\n    height: 48px;\n    font-size: 20px;\n  }\n  \n  .contact-name {\n    font-size: 16px;\n  }\n  \n  .contact-last-message {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .contact-item {\n    padding: 14px;\n    min-height: 68px;\n  }\n  \n  .contact-avatar {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n}\n\n.admin-badge {\n  margin-left: 8px;\n  font-size: 12px;\n  background-color: #f59e0b;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.contact-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #6b7280;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-right: 12px;\n  font-size: 18px;\n}\n\n.contact-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.contact-name {\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contact-last-message {\n  font-size: 14px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contact-meta {\n  text-align: right;\n  margin-left: 8px;\n}\n\n.contact-time {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n\n.message-count {\n  background-color: #00a884;\n  color: white;\n  font-size: 12px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 20px;\n  text-align: center;\n}\n\n.chat-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #efeae2;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4d4aa' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  position: relative; /* Add relative positioning for scroll button */\n}\n\n/* Mobile Chat Area */\n@media (max-width: 768px) {\n  .chat-area {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 90;\n  }\n  \n  .chat-area.hidden-mobile {\n    display: none;\n  }\n}\n\n.chat-header {\n  background-color: #f0f2f5;\n  padding: 16px 20px;\n  border-bottom: 1px solid #d1d7db;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Mobile Back Button */\n.mobile-back-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #54656f;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n  min-width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mobile-back-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n/* Mobile Chat Header */\n@media (max-width: 768px) {\n  .chat-header {\n    padding: 12px 16px;\n  }\n}\n\n.chat-contact-info {\n  display: flex;\n  align-items: center;\n}\n\n.chat-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #6b7280;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-right: 12px;\n  font-size: 16px;\n}\n\n.chat-name {\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\n.chat-status {\n  font-size: 13px;\n  color: #667781;\n}\n\n.messages-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');\n  background-size: auto;\n}\n\n/* Mobile Messages Container */\n@media (max-width: 768px) {\n  .messages-container {\n    padding: 10px 15px;\n  }\n}\n\n/* Scroll to Bottom Button */\n.scroll-to-bottom {\n  position: absolute;\n  bottom: 80px;\n  right: 20px;\n  z-index: 10;\n}\n\n.scroll-to-bottom-btn {\n  background: #00a884;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  animation: slideUp 0.3s ease-out;\n  white-space: nowrap;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.scroll-to-bottom-btn:hover {\n  background: #008f70;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.scroll-to-bottom-btn:active {\n  transform: translateY(0);\n}\n\n/* Mobile Scroll Button */\n@media (max-width: 768px) {\n  .scroll-to-bottom {\n    bottom: 70px;\n    right: 16px;\n  }\n  \n  .scroll-to-bottom-btn {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n}\n\n/* Drag and Drop Overlay */\n.drag-drop-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 168, 132, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  border: 3px dashed rgba(255, 255, 255, 0.8);\n  border-radius: 12px;\n  backdrop-filter: blur(5px);\n}\n\n.drag-drop-content {\n  text-align: center;\n  color: white;\n  pointer-events: none;\n}\n\n.drag-drop-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n  animation: bounce 1s infinite;\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n.drag-drop-content h3 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.drag-drop-content p {\n  margin: 0;\n  font-size: 16px;\n  opacity: 0.9;\n}\n\n/* Mobile Drag and Drop */\n@media (max-width: 768px) {\n  .drag-drop-icon {\n    font-size: 48px;\n    margin-bottom: 12px;\n  }\n  \n  .drag-drop-content h3 {\n    font-size: 20px;\n  }\n  \n  .drag-drop-content p {\n    font-size: 14px;\n  }\n}\n\n.message {\n  display: flex;\n  margin-bottom: 2px;\n  animation: messageSlideIn 0.2s ease-out;\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message.sent {\n  justify-content: flex-end;\n}\n\n.message.received {\n  justify-content: flex-start;\n}\n\n.message-content {\n  max-width: 65%;\n  min-width: 100px;\n  background-color: white;\n  border-radius: 7.5px;\n  padding: 6px 7px 8px 9px;\n  box-shadow: 0 1px 0.5px rgba(0,0,0,0.13);\n  position: relative;\n  word-wrap: break-word;\n}\n\n.message.sent .message-content {\n  background-color: #d9fdd3;\n  border-radius: 7.5px 7.5px 0px 7.5px;\n}\n\n.message.received .message-content {\n  background-color: #ffffff;\n  border-radius: 7.5px 7.5px 7.5px 0px;\n}\n\n.message-text {\n  margin: 0;\n  color: #111827;\n  line-height: 1.4;\n  word-wrap: break-word;\n  font-size: 14px;\n}\n\n.message-time {\n  font-size: 11px;\n  color: #667781;\n  margin-top: 2px;\n  float: right;\n  margin-left: 10px;\n}\n\n.message-status {\n  color: #53bdeb;\n  margin-left: 3px;\n}\n\n.media-message {\n  max-width: 300px;\n}\n\n.image-container {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.message-image {\n  width: 100%;\n  max-width: 300px;\n  border-radius: 8px;\n  display: block;\n  transition: all 0.2s ease;\n}\n\n.clickable-image {\n  cursor: pointer;\n}\n\n.clickable-image:hover {\n  opacity: 0.9;\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.media-placeholder {\n  background-color: #f3f4f6;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.document-message {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 4px;\n}\n\n.document-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.document-icon {\n  font-size: 24px;\n  color: #6b7280;\n}\n\n.document-details {\n  flex: 1;\n  min-width: 0; /* Allow text truncation */\n}\n\n.document-name {\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.document-size {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.download-btn {\n  background-color: #00a884;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.download-btn:hover {\n  background-color: #008a73;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n/* Audio Message Styles */\n.audio-container {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 12px;\n  max-width: 350px;\n}\n\n.message-audio {\n  width: 100%;\n  height: 40px;\n  margin-bottom: 8px;\n  border-radius: 20px;\n  outline: none;\n}\n\n.message-audio::-webkit-media-controls-panel {\n  background-color: #f3f4f6;\n  border-radius: 20px;\n}\n\n.message-audio::-webkit-media-controls-play-button,\n.message-audio::-webkit-media-controls-pause-button {\n  background-color: #00a884;\n  border-radius: 50%;\n}\n\n.audio-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.audio-icon {\n  font-size: 20px;\n  color: #00a884;\n}\n\n.audio-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.audio-name {\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.audio-size {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.audio-message {\n  background-color: #f3f4f6;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Video Message Styles */\n.video-container {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 12px;\n  max-width: 400px;\n}\n\n.message-video {\n  width: 100%;\n  max-width: 100%;\n  max-height: 300px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background-color: #000;\n}\n\n.message-video::-webkit-media-controls-panel {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.message-video::-webkit-media-controls-play-button,\n.message-video::-webkit-media-controls-pause-button {\n  background-color: #00a884;\n  border-radius: 50%;\n}\n\n.video-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.video-icon {\n  font-size: 20px;\n  color: #00a884;\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.video-name {\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 2px;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.video-size {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.video-message {\n  background-color: #f3f4f6;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Media Player Responsive Design */\n@media (max-width: 768px) {\n  .audio-container,\n  .video-container {\n    max-width: 280px;\n  }\n  \n  .message-video {\n    max-height: 200px;\n  }\n  \n  .message-audio {\n    height: 35px;\n  }\n  \n  .audio-info,\n  .video-info {\n    gap: 8px;\n  }\n  \n  .audio-name,\n  .video-name {\n    font-size: 13px;\n  }\n  \n  .audio-size,\n  .video-size {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .audio-container,\n  .video-container {\n    max-width: 250px;\n  }\n  \n  .message-video {\n    max-height: 150px;\n  }\n  \n  .download-btn {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n/* Media Loading and Error States */\n.media-loading {\n  display: none;\n  text-align: center;\n  padding: 10px;\n  color: #6b7280;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.audio-error,\n.video-error {\n  display: none;\n  text-align: center;\n  padding: 10px;\n  color: #ef4444;\n  font-size: 14px;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  margin: 8px 0;\n}\n\n/* Custom Media Controls Styling */\n.message-audio::-webkit-media-controls-timeline,\n.message-video::-webkit-media-controls-timeline {\n  background-color: #e5e7eb;\n  border-radius: 4px;\n}\n\n.message-audio::-webkit-media-controls-current-time-display,\n.message-audio::-webkit-media-controls-time-remaining-display,\n.message-video::-webkit-media-controls-current-time-display,\n.message-video::-webkit-media-controls-time-remaining-display {\n  color: #374151;\n  font-size: 12px;\n}\n\n.message-audio::-webkit-media-controls-volume-slider,\n.message-video::-webkit-media-controls-volume-slider {\n  background-color: #e5e7eb;\n  border-radius: 4px;\n}\n\n.download-btn:hover {\n  background-color: #059669;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.download-btn:active {\n  transform: translateY(0);\n}\n\n.media-caption {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.file-size {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.audio-message, .video-message {\n  background-color: #f3f4f6;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.message-input-container {\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  background-color: #f0f2f5;\n  gap: 12px;\n}\n\n/* Mobile Input Container */\n@media (max-width: 768px) {\n  .message-input-container {\n    padding: 12px 16px;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .message-input-container {\n    padding: 10px 12px;\n    gap: 6px;\n  }\n}\n\n.attach-btn, .send-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #54656f;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n/* Mobile Touch-Friendly Buttons */\n@media (max-width: 768px) {\n  .attach-btn, .send-btn {\n    padding: 12px;\n    font-size: 22px;\n    min-width: 44px;\n    height: 44px;\n  }\n  \n  .new-chat-btn, .refresh-btn {\n    padding: 12px;\n    font-size: 18px;\n    min-width: 44px;\n    height: 44px;\n  }\n}\n\n@media (max-width: 480px) {\n  .attach-btn, .send-btn {\n    padding: 10px;\n    font-size: 20px;\n    min-width: 40px;\n    height: 40px;\n  }\n}\n\n.attach-btn:hover, .send-btn:hover {\n  background-color: #e5e7eb;\n}\n\n.message-input {\n  flex: 1;\n  border: none;\n  border-radius: 24px;\n  padding: 12px 16px;\n  font-size: 15px;\n  background-color: white;\n  outline: none;\n}\n\n/* Mobile Message Input */\n@media (max-width: 768px) {\n  .message-input {\n    padding: 10px 14px;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n}\n\n@media (max-width: 480px) {\n  .message-input {\n    padding: 8px 12px;\n    border-radius: 20px;\n  }\n}\n\n.message-input:focus {\n  box-shadow: 0 0 0 2px #00a884;\n}\n\n.no-chat-selected {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  color: #667781;\n}\n\n/* Mobile No Chat Selected */\n@media (max-width: 768px) {\n  .no-chat-selected {\n    padding: 20px;\n  }\n  \n  .no-chat-content h3 {\n    font-size: 18px;\n  }\n  \n  .feature-list p {\n    font-size: 14px;\n  }\n}\n\n.no-chat-content h3 {\n  margin-bottom: 16px;\n  color: #111827;\n}\n\n.feature-list {\n  margin-top: 24px;\n}\n\n.feature-list p {\n  margin: 8px 0;\n  color: #6b7280;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: white;\n  border-radius: 12px;\n  padding: 0;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.modal-close:hover {\n  background-color: #f3f4f6;\n}\n\n.modal-content {\n  padding: 20px 24px;\n}\n\n.modal-footer {\n  padding: 16px 24px 20px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.btn-cancel, .btn-send {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: none;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-cancel {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.btn-cancel:hover {\n  background-color: #e5e7eb;\n}\n\n.btn-send {\n  background-color: #00a884;\n  color: white;\n}\n\n.btn-send:hover {\n  background-color: #059669;\n}\n\n.btn-send:disabled {\n  background-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* New Chat Form */\n.new-chat-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.new-chat-form label {\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 4px;\n}\n\n.phone-input {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.phone-input:focus {\n  border-color: #00a884;\n}\n\n.phone-help {\n  background-color: #f0f9ff;\n  padding: 12px;\n  border-radius: 6px;\n  border-left: 4px solid #0ea5e9;\n}\n\n.phone-help small {\n  color: #0369a1;\n  line-height: 1.5;\n}\n\n/* File Preview */\n.file-preview {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.file-icon {\n  font-size: 24px;\n}\n\n.file-name {\n  font-weight: 500;\n  color: #111827;\n}\n\n.file-size {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.image-preview {\n  max-width: 100%;\n  max-height: 200px;\n  border-radius: 6px;\n}\n\n.caption-input {\n  width: 100%;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px;\n  font-size: 14px;\n  outline: none;\n  resize: vertical;\n  min-height: 80px;\n  transition: border-color 0.2s;\n}\n\n.caption-input:focus {\n  border-color: #00a884;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 100;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n  \n  .sidebar.open {\n    transform: translateX(0);\n  }\n  \n  .message-content {\n    max-width: 85%;\n  }\n  \n  .modal {\n    width: 95%;\n    margin: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
